import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Unit, LocationUnits, UnitService } from 'services/unit.service';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { Location, LocationService } from 'services/location.service'
import { PlatformService } from "services/platform.service";
import { MetaService } from 'services/meta.service';

@Component({
	selector: 'ras-location-page',
	templateUrl: './location-page.component.html',
	styleUrls: ['./location-page.component.sass']
})
export class LocationPageComponent implements OnInit {

	public loading_units: boolean = false;
	public loading_units_failed: boolean = false;
	public loading_units_state: string = "not loaded";
	public location_key: string
	public location: Location = null
	public show_site_tour = false
	public units: LocationUnits = null
	videos = [
		{
			code: '-086NoMci6U',
			preview: '/assets/video-Jabu.jpg',
			position: '20%'
		},
		{
			code: 'zIrpM6-VfJY',
			preview: '/assets/video-Santiago.jpg',
			position: '10%'
		},
	]
	video = null;

	private params_sub: any = null

	constructor(private titleService: Title, private meta: MetaService, private route: ActivatedRoute, private locationService: LocationService, private unitService: UnitService, private platform: PlatformService) { }

	load_units() {
		if (!this.loading_units) {
			this.loading_units_state = "loading";
			this.loading_units = true;
			this.loading_units_failed = false;
			this.unitService.get_units(this.location.id)
			.then(data => {
				if (data) {
					this.units = data;
					this.loading_units_state = "loaded";
				}
			})
			.catch(err => {
				console.warn(err)
				this.loading_units_failed = true;
				this.loading_units_state = "failed";
			})
			.finally(() => {
				this.loading_units = false;
			})
		}
	}

	ngOnDestroy() {
		if (this.params_sub) {
			this.params_sub.unsubscribe()
		}
	}

	ngOnInit() {
		if (this.videos.length > 0) {
			let video_i = Math.floor(Math.random()*this.videos.length);
			this.video = this.videos[video_i];
		}

		this.params_sub = this.route.paramMap.subscribe(params => {
			this.location_key = params.get('location')

			this.locationService.get(this.location_key)
			.then(location => {
				this.location = location

				this.titleService.setTitle("Storage in " + location.name + " - Rent-A-Store")
				this.meta.setMeta('keywords', "storage in " + location.name + ", storage units " + location.name)
				this.meta.setMeta('description', "Rent affordable storage in " + location.name + ". Rent-A-Store offers secure storage units in " + location.name + ", designed to accommodate all your self-storage needs.")

				if (this.platform.isBrowser) {
					window.scrollTo(0, 0)

					this.load_units();
				}
			})
		})
	}

}
